var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('h2',[_vm._v("Careers (Upcoming)")]),_c('ul',[_c('li',[_vm._v(" Build resume ")]),_c('li',[_vm._v(" Find suitable job ")]),_c('li',[_vm._v(" Connect best employer ")])]),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br')])
}]

export { render, staticRenderFns }